/* Sinezy26 — JS scopé au template product.sinezy26.json.
   Ce fichier est référencé (même src) par les 14 sections pour rester robuste
   à la réorganisation/suppression de n'importe quel bloc depuis l'éditeur de thème.
   Le tag <script> est donc rencontré plusieurs fois dans le DOM : on protège
   l'exécution avec un garde pour ne l'initialiser qu'une seule fois. */
(function () {
  if (window.__sinezyProductJsLoaded) return;
  window.__sinezyProductJsLoaded = true;

  function getProductData() {
    const el = document.querySelector('[data-sinezy-product]');
    if (!el) return null;
    try { return JSON.parse(el.textContent); } catch (e) { return null; }
  }

  function findVariantByOptionValue(product, value) {
    if (!product || !value) return null;
    const exact = product.variants.find(function (v) { return v.option1 === value; });
    if (exact) return exact;
    const norm = String(value).trim().toLowerCase();
    return product.variants.find(function (v) { return String(v.option1 || '').trim().toLowerCase() === norm; }) || null;
  }

  function findVariantById(product, id) {
    if (!product) return null;
    const idStr = String(id);
    return product.variants.find(function (v) { return String(v.id) === idStr; }) || null;
  }

  /* =====================================================================
     BUNDLE-STACK / VARIANT-SELECT — une instance par .sz-variant-select
     trouvée sur la page (bloc 00 buy-box, bloc 10 offre). La cible est
     résolue via data-bundle-target -> id, pas via une position DOM relative
     (previousElementSibling), pour rester robuste si un wrapper (ex. le
     <form> d'ajout panier) s'intercale entre les deux éléments. Chaque
     instance gère son propre état (mode kit/solo) et son propre formulaire
     d'ajout panier, sans dépendre des autres instances.
     ===================================================================== */
  function initBundleStacks(product) {
    document.querySelectorAll('.sz-variant-select[data-bundle-target]').forEach(function (selectGroup) {
      const stack = document.getElementById(selectGroup.dataset.bundleTarget);
      if (!stack) return;
      const main = stack.querySelector('.sz-bundle-main');
      const link = stack.querySelector('.sz-bundle-alt-link');
      const form = stack.closest('[data-sinezy-buy-form]');
      const hiddenId = form ? form.querySelector('input[name="id"]') : null;
      const d = stack.dataset;
      let mode = 'kit';

      function render() {
        const optionValue = mode === 'kit' ? d.kitValue : d.soloValue;
        const variant = findVariantByOptionValue(product, optionValue);
        const fallbackName = mode === 'kit' ? d.kitName : d.soloName;
        const badge = mode === 'kit' ? (d.kitBadge || ('★ ' + d.kitName)) : (d.soloBadge || d.soloName);
        const sub = mode === 'kit' ? d.kitSub : d.soloSub;
        const fallbackItems = (mode === 'kit' ? d.kitItems : d.soloItems).split('|');
        const items = (variant && variant.bundleItems && variant.bundleItems.length) ? variant.bundleItems : fallbackItems;

        const fallbackPrice = mode === 'kit' ? d.kitPrice : d.soloPrice;
        const fallbackStrike = mode === 'kit' ? d.kitStrike : d.soloStrike;
        const showComparePrice = (mode === 'kit' ? d.kitShowComparePrice : d.soloShowComparePrice) !== 'false';
        const showProtocol = (mode === 'kit' ? d.kitShowProtocol : d.soloShowProtocol) !== 'false';
        const protocolIcon = mode === 'kit' ? d.kitProtocolIcon : d.soloProtocolIcon;
        const protocolTitle = mode === 'kit' ? d.kitProtocolTitle : d.soloProtocolTitle;
        const protocolBadge = mode === 'kit' ? d.kitProtocolBadge : d.soloProtocolBadge;
        const protocolSub = mode === 'kit' ? d.kitProtocolSub : d.soloProtocolSub;

        if (main) {
          const badgeEl = main.querySelector('.sz-bundle-badge');
          if (badgeEl) badgeEl.textContent = badge;
          main.querySelector('.sz-bundle-name').textContent = fallbackName;
          main.querySelector('.sz-bundle-sub').textContent = sub;
          main.querySelector('.sz-price-strike').textContent = showComparePrice ? ((variant && variant.compareAtPrice) ? variant.compareAtPrice : (fallbackStrike || '')) : '';
          main.querySelector('.sz-bundle-price').textContent = variant ? variant.price : (fallbackPrice || '');
          main.querySelector('.sz-bundle-check').innerHTML = items.map(function (i) { return '<li>' + i + '</li>'; }).join('');
          const protocolEl = main.querySelector('.sz-protocol-callout');
          if (protocolEl) {
            protocolEl.style.display = showProtocol ? '' : 'none';
            if (showProtocol) {
              const iconEl = protocolEl.querySelector('.sz-pc-icon');
              const titleEl = protocolEl.querySelector('.sz-pc-title-text');
              const badgeTextEl = protocolEl.querySelector('.sz-pc-badge');
              const subEl = protocolEl.querySelector('.sz-pc-sub');
              if (iconEl) iconEl.textContent = protocolIcon || '';
              if (titleEl) titleEl.textContent = protocolTitle || '';
              if (badgeTextEl) badgeTextEl.textContent = protocolBadge || '';
              if (subEl) subEl.textContent = protocolSub || '';
            }
          }
        }

        if (hiddenId && variant) hiddenId.value = variant.id;

        selectGroup.querySelectorAll('.sz-variant-box').forEach(function (b) {
          b.classList.toggle('selected', b.dataset.mode === mode);
        });

        if (link && d.soloValue) {
          const soloVariant = findVariantByOptionValue(product, d.soloValue);
          const kitVariant = findVariantByOptionValue(product, d.kitValue);
          link.innerHTML = mode === 'kit'
            ? 'Vous préférez l\'appareil seul&nbsp;? <b>' + (soloVariant ? soloVariant.price : d.soloPrice) + '</b> →'
            : '← Revenir au Kit Complet <b>' + (kitVariant ? kitVariant.price : d.kitPrice) + '</b>';
        }

        if (variant) {
          document.dispatchEvent(new CustomEvent('sinezy:variant-change', { detail: { variantId: variant.id, mode: mode } }));
        }
      }

      if (link) link.addEventListener('click', function () { mode = mode === 'kit' ? 'solo' : 'kit'; render(); });
      selectGroup.querySelectorAll('.sz-variant-box').forEach(function (box) {
        box.addEventListener('click', function () { mode = box.dataset.mode; render(); });
      });

      render();
    });
  }

  /* =====================================================================
     GALERIE PRODUIT — sz-gallery
     Même comportement en desktop et en mobile : une grande image (featured)
     + une bande de vignettes qui défile horizontalement (grid).
     Aucune bascule de layout par media query : seules les tailles changent.
     ===================================================================== */
  function initGallery(product) {
    const root = document.getElementById('sz-gallery');
    if (!root) return;
    const featuredImg = document.getElementById('sz-gallery-featured-img');
    const items = Array.from(root.querySelectorAll('.sz-gallery__item'));
    if (!items.length) return;
    let activeIndex = 0;
    let currentFull = null;
    let currentSrc = featuredImg ? featuredImg.getAttribute('src') : null;

    /* Applique une image en featured avec un fondu FLUIDE, sans flash blanc :
       on précharge et on DÉCODE la nouvelle image avant de basculer la src, de
       sorte que l'échange soit instantané (image prête). Fondu doux (opacité
       0.55 -> 1) piloté par la transition CSS. Aucun état transparent/vide. */
    function setFeatured(src, full, alt) {
      currentFull = full || src || null;
      if (!src) return;
      if (currentSrc === src) { featuredImg.alt = alt || ''; return; } // déjà affichée
      var apply = function () {
        currentSrc = src;
        featuredImg.style.opacity = '0.55';
        featuredImg.src = src;              // déjà décodée -> pas de blanc
        featuredImg.alt = alt || '';
        requestAnimationFrame(function () { featuredImg.style.opacity = '1'; });
      };
      var pre = new Image();
      pre.src = src;
      if (pre.decode) {
        pre.decode().then(apply).catch(apply);
      } else if (pre.complete) {
        apply();
      } else {
        pre.onload = apply;
        pre.onerror = apply;
      }
    }

    function showImage(idx) {
      const item = items[idx];
      if (!item) return;
      activeIndex = idx;
      setFeatured(item.dataset.src || item.dataset.full || '', item.dataset.full || item.dataset.src || '', item.dataset.alt || '');
      items.forEach(function (i) { i.classList.remove('is-active'); });
      item.classList.add('is-active');
      item.scrollIntoView({ inline: 'center', block: 'nearest', behavior: 'smooth' });
    }

    items.forEach(function (item, idx) {
      item.addEventListener('click', function () { showImage(idx); });
    });

    /* Fondu du bord droit de la bande de vignettes : visible tant qu'il reste
       à défiler, masqué (is-end) une fois au bout ou si tout tient à l'écran. */
    const grid = document.getElementById('sz-gallery-grid');
    const gridWrap = grid ? grid.parentElement : null;
    function updateGridFade() {
      if (!grid || !gridWrap) return;
      const scrollable = grid.scrollWidth - grid.clientWidth;
      const atEnd = scrollable <= 2 || grid.scrollLeft >= scrollable - 2;
      gridWrap.classList.toggle('is-end', atEnd);
    }
    if (grid) {
      grid.addEventListener('scroll', updateGridFade, { passive: true });
      window.addEventListener('resize', updateGridFade);
      window.addEventListener('load', updateGridFade);
      updateGridFade();
    }

    const featuredWrap = root.querySelector('.sz-gallery__featured');
    featuredWrap.addEventListener('click', function () {
      const full = currentFull || (items[activeIndex] ? (items[activeIndex].dataset.full || items[activeIndex].dataset.src) : null);
      if (!full) return;
      const overlay = document.createElement('div');
      overlay.className = 'sz-lightbox';
      overlay.innerHTML = '<img src="' + full + '" alt=""><button type="button" aria-label="Fermer">✕</button>';
      overlay.addEventListener('click', function () { overlay.remove(); });
      document.body.appendChild(overlay);
    });

    let touchStartX = 0, touchStartY = 0;
    featuredWrap.addEventListener('touchstart', function (e) {
      touchStartX = e.changedTouches[0].clientX;
      touchStartY = e.changedTouches[0].clientY;
    }, { passive: true });
    featuredWrap.addEventListener('touchend', function (e) {
      const dx = e.changedTouches[0].clientX - touchStartX;
      const dy = e.changedTouches[0].clientY - touchStartY;
      if (Math.abs(dx) < 40 || Math.abs(dx) < Math.abs(dy)) return;
      const next = dx < 0 ? Math.min(activeIndex + 1, items.length - 1) : Math.max(activeIndex - 1, 0);
      showImage(next);
    }, { passive: true });

    /* Resynchronisation avec la variante choisie.
       Ordre de priorité :
       1. Vignette assignée nativement (data-variant-ids) à ce variantId → on la
          met en featured ET on l'active dans la bande.
       2. Sinon, image assignée à la variante côté Shopify (variant.featured_image)
          même si elle N'EST PAS dans la bande des 8 vignettes → on l'affiche
          directement en featured, sans vignette active.
       3. Sinon, première image commune (sans variante assignée). */
    document.addEventListener('sinezy:variant-change', function (e) {
      const variantId = String(e.detail.variantId);

      let idx = items.findIndex(function (i) {
        const ids = (i.dataset.variantIds || '').split(',').filter(Boolean);
        return ids.includes(variantId);
      });
      if (idx !== -1) { showImage(idx); return; }

      const variant = product && product.variants
        ? product.variants.find(function (v) { return String(v.id) === variantId; })
        : null;
      if (variant && variant.featuredImage) {
        setFeatured(variant.featuredImage, variant.featuredImageFull, variant.featuredImageAlt);
        items.forEach(function (i) { i.classList.remove('is-active'); });
        activeIndex = -1;
        return;
      }

      idx = items.findIndex(function (i) { return !i.dataset.variantIds; });
      if (idx !== -1) showImage(idx);
    });

    showImage(0);
  }

  /* =====================================================================
     BARRE STICKY MOBILE — reflète la dernière variante sélectionnée,
     quel que soit le bundle-stack qui a émis le changement.
     ===================================================================== */
  function initMobileBar(product) {
    const bar = document.querySelector('.sz-mobile-bar');
    if (!bar) return;
    const priceEl = bar.querySelector('.sz-price');
    const hiddenId = bar.querySelector('input[name="id"]');

    document.addEventListener('sinezy:variant-change', function (e) {
      const variant = findVariantById(product, e.detail.variantId);
      if (!variant) return;
      if (hiddenId) hiddenId.value = variant.id;
      if (priceEl) {
        priceEl.innerHTML = variant.price + ' <small>' + variant.title + '</small>';
      }
    });
  }

  /* =====================================================================
     COMPLÉMENTS (cross-sell) — cases à cocher indépendantes, style bouton.
     ===================================================================== */
  function initAddons() {
    document.querySelectorAll('.sz-addon-item').forEach(function (item) {
      item.addEventListener('click', function () {
        item.classList.toggle('selected');
      });
    });
  }

  function getSelectedAddonItems() {
    return Array.from(document.querySelectorAll('.sz-addon-item.selected'))
      .filter(function (el) { return el.dataset.available !== 'false' && el.dataset.variantId; })
      .map(function (el) { return { id: el.dataset.variantId, quantity: 1 }; });
  }

  /* =====================================================================
     AJOUT PANIER MULTI-ARTICLES — un seul appel /cart/add.js pour le
     produit principal + les compléments cochés. Suit le pattern natif de
     Dawn (product-form.js) : sections=cart-drawer/cart-notification en
     paramètre pour récupérer le HTML à jour, puis cart.renderContents()
     qui met à jour ET ouvre le tiroir/la notification. Reste compatible
     avec les deux réglages de panier du thème (drawer ou notification).
     ===================================================================== */
  function getCartComponent() {
    return document.querySelector('cart-drawer') || document.querySelector('cart-notification');
  }

  function cartMultiAdd(items, triggerEl) {
    items = (items || []).filter(function (i) { return i && i.id; });
    if (!items.length) return;
    const cart = getCartComponent();
    const formData = new FormData();
    items.forEach(function (item, idx) {
      formData.append('items[' + idx + '][id]', item.id);
      formData.append('items[' + idx + '][quantity]', item.quantity || 1);
    });
    if (cart && typeof cart.getSectionsToRender === 'function') {
      formData.append('sections', cart.getSectionsToRender().map(function (s) { return s.id; }).join(','));
      formData.append('sections_url', window.location.pathname);
      if (typeof cart.setActiveElement === 'function' && triggerEl) cart.setActiveElement(triggerEl);
    }
    if (triggerEl) triggerEl.classList.add('sz-loading');

    fetch(window.routes.cart_add_url, {
      method: 'POST',
      headers: { Accept: 'application/javascript' },
      body: formData,
    })
      .then(function (r) { return r.json(); })
      .then(function (response) {
        if (triggerEl) triggerEl.classList.remove('sz-loading');
        if (response.status) {
          if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
            publish(PUB_SUB_EVENTS.cartError, { source: 'sinezy-product', errors: response.errors, message: response.message });
          }
          return;
        }
        // --- Tracking GTM : rhr_add_to_cart (structure ecommerce.items, item_id = product_id) ---
        try {
          window.dataLayer = window.dataLayer || [];
          window.dataLayer.push({ ecommerce: null }); // reset
          var addedItems = response.items || (response.id ? [response] : []);
          window.dataLayer.push({
            event: 'rhr_add_to_cart',
            ecommerce: {
              items: addedItems.map(function (it) {
                return {
                  item_id: String(it.product_id),
                  item_name: it.product_title,
                  price: (it.price || 0) / 100,
                  quantity: it.quantity,
                };
              }),
            },
          });
        } catch (e) {}
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          publish(PUB_SUB_EVENTS.cartUpdate, { source: 'sinezy-product', cartData: response });
        }
        if (cart && typeof cart.renderContents === 'function') {
          cart.renderContents(response);
        } else {
          window.location.href = window.routes.cart_url;
        }
      })
      .catch(function () {
        if (triggerEl) triggerEl.classList.remove('sz-loading');
      });
  }

  /* Intercepte les formulaires d'achat (bloc 00, bloc 10) et le bouton de
     la barre sticky mobile pour regrouper produit principal + compléments
     cochés dans un seul ajout panier. */
  function initBuyActions() {
    document.querySelectorAll('[data-sinezy-buy-form]').forEach(function (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        const hiddenId = form.querySelector('input[name="id"]');
        if (!hiddenId || !hiddenId.value) return;
        const items = [{ id: hiddenId.value, quantity: 1 }].concat(getSelectedAddonItems());
        cartMultiAdd(items, form.querySelector('button[type="submit"]'));
      });
    });

    const mobileBtn = document.querySelector('[data-sinezy-mobile-add]');
    if (mobileBtn) {
      mobileBtn.addEventListener('click', function () {
        const hiddenId = document.querySelector('.sz-mobile-bar input[name="id"]');
        if (!hiddenId || !hiddenId.value) return;
        const items = [{ id: hiddenId.value, quantity: 1 }].concat(getSelectedAddonItems());
        cartMultiAdd(items, mobileBtn);
      });
    }
  }

  /* Le widget Judge.me (bloc 08) charge/remplace ses avis en AJAX après coup, potentiellement
     plusieurs fois (rendu initial, hydratation) : les nœuds qu'on cible peuvent donc être
     recréés. On utilise la délégation d'évènements (jamais de référence directe à un nœud
     qui pourrait devenir obsolète) et des drapeaux posés sur les éléments eux-mêmes
     (pas une variable fermée) pour rester robuste à ces remplacements. */
  function initJudgemeReviews() {
    document.addEventListener('click', function (e) {
      const showMoreBtn = e.target.closest('.sz-jdgm-showmore');
      if (!showMoreBtn) return;
      const list = document.querySelector('.jdgm-rev-widg__reviews');
      if (list) {
        list.classList.remove('sz-jdgm-collapsed');
        list.dataset.szJdgmExpanded = 'true';
      }
      showMoreBtn.remove();
    });

    /* Le lazy-load des photos/vidéos de Judge.me ne se déclenche pas de façon fiable
       dans ce contexte (constaté même après un vrai scroll) : on copie nous-mêmes
       data-src -> src dès que l'avis est dans le DOM, sans attendre leur détection.
       On utilise le href du lien (plein format, ex. width=1024 pour la lightbox)
       plutôt que le data-src de la vignette (ex. width=160, bien trop petit pour
       une image affichée en grand dans la carte — d'où le flou constaté). */
    function fixLazyMedia(review) {
      review.querySelectorAll('.jdgm-rev__pic-link').forEach(function (link) {
        const img = link.querySelector('img[data-src]');
        if (img && !img.getAttribute('src')) {
          img.src = link.getAttribute('href') || link.dataset.mfpSrc || img.dataset.src;
        }
      });
      review.querySelectorAll('img[data-src]:not([src])').forEach(function (img) {
        img.src = img.dataset.src;
      });
      review.querySelectorAll('.jdgm-rev__pic-link.jdgm--loading').forEach(function (link) {
        link.classList.remove('jdgm--loading');
      });
    }

    /* Badge "Avis vérifié" forcé : Judge.me ne rend même pas l'élément pour les avis
       qu'il ne marque pas comme achat vérifié — on l'injecte s'il manque. */
    function forceVerifiedBadge(review) {
      const wrapper = review.querySelector('.jdgm-rev__buyer-badge-wrapper');
      if (!wrapper || wrapper.querySelector('.jdgm-rev__buyer-badge, .sz-jdgm-badge')) return;
      const badge = document.createElement('span');
      badge.className = 'sz-jdgm-badge';
      wrapper.appendChild(badge);
    }

    /* Le badge vit nativement dans .jdgm-rev__header (à côté du nom) : on le déplace
       après l'avis pour libérer la colonne de droite (photo/vidéo) sur toute sa hauteur. */
    function relocateBadge(review) {
      const wrapper = review.querySelector('.jdgm-rev__buyer-badge-wrapper');
      const content = review.querySelector('.jdgm-rev__content');
      if (wrapper && content && wrapper.parentElement !== content) {
        content.appendChild(wrapper);
      }
    }

    /* Judge.me rend toujours .jdgm-rev__reply même sans réponse de la marque : on masque
       le bandeau crème quand il est vide pour éviter une barre flottante sans texte. */
    function hideEmptyReply(review) {
      const reply = review.querySelector('.jdgm-rev__reply');
      if (reply && !reply.textContent.trim()) {
        reply.style.display = 'none';
      }
    }

    /* Photo/vidéo jointe : vit nativement dans .jdgm-rev__content, imbriquée avec le
       titre/l'avis. On la déplace en enfant direct de la carte pour qu'elle devienne
       une vraie colonne de grille CSS (grid-column:2) — un display:contents sur le
       parent pour la faire "remonter" au lieu de la déplacer se calculait à une
       largeur de colonne de 0px de façon incohérente selon les navigateurs. */
    function relocateMedia(review) {
      ['.jdgm-rev__pics', '.jdgm-rev__vids'].forEach(function (sel) {
        const el = review.querySelector(sel);
        if (el && el.parentElement !== review) {
          review.appendChild(el);
        }
      });
    }

    function setupSummary() {
      const header = document.querySelector('.jdgm-rev-widg__header');
      if (!header || header.dataset.szJdgmInit) return;
      header.dataset.szJdgmInit = 'true';
      const ratingLink = document.querySelector('.sz-rating-link');
      const rating = (ratingLink && ratingLink.dataset.rating) || '4,89/5';
      const reviews = (ratingLink && ratingLink.dataset.reviews) || '748 avis';
      const ratingNum = parseFloat(String(rating).replace(',', '.')) || 4.8;
      const ratingRounded = Math.floor(ratingNum * 2) / 2;
      const starFillPct = Math.max(0, Math.min(100, (ratingRounded / 5) * 100));
      const summary = document.createElement('div');
      summary.className = 'sz-jdgm-summary';
      summary.innerHTML =
        '<span class="sz-jdgm-summary__stars" style="--star-fill:' + starFillPct + '%">★★★★★</span>' +
        '<span class="sz-jdgm-summary__text">' + rating + ' · ' + reviews + '</span>';
      header.insertAdjacentElement('afterbegin', summary);
    }

    /* Le widget Judge.me est en anglais ("Write a review") : on force le libellé en
       français plutôt que de dépendre du réglage de langue de l'app. */
    function relabelWriteReviewButton() {
      document.querySelectorAll('.jdgm-write-rev-link').forEach(function (btn) {
        if (btn.textContent.trim() !== 'Laisser un avis') {
          btn.textContent = 'Laisser un avis';
        }
      });
    }

    function processReviews(list) {
      const reviews = list.querySelectorAll(':scope > .jdgm-rev');
      if (!reviews.length) return;

      reviews.forEach(function (review) {
        if (review.dataset.szJdgmFixed) return;
        review.dataset.szJdgmFixed = 'true';
        fixLazyMedia(review);
        forceVerifiedBadge(review);
        relocateBadge(review);
        relocateMedia(review);
        hideEmptyReply(review);
      });

      /* Pas de verrou "une seule fois" ici : Judge.me peut peupler ses avis
         progressivement, et un premier passage avec moins de 8 avis présents
         verrouillerait sinon définitivement l'apparition du bouton. On ne
         reverrouille que si l'utilisateur a déjà cliqué sur "Lire plus d'avis". */
      if (list.dataset.szJdgmExpanded) return;
      if (window.matchMedia('(max-width: 760px)').matches && reviews.length > 7) {
        list.classList.add('sz-jdgm-collapsed');
        if (!document.querySelector('.sz-jdgm-showmore')) {
          const btn = document.createElement('button');
          btn.type = 'button';
          btn.className = 'sz-jdgm-showmore';
          btn.textContent = "Lire plus d'avis";
          list.insertAdjacentElement('afterend', btn);
        }
      } else {
        list.classList.remove('sz-jdgm-collapsed');
      }
    }

    /* Une fois la liste d'avis trouvée, on lui pose un observateur dédié (plus léger et
       plus fiable qu'un seul observateur global sur <body>, qui peut être retardé par le
       navigateur en cas de forte activité DOM ailleurs sur la page). */
    let listObserver = null;
    function tick() {
      setupSummary();
      relabelWriteReviewButton();
      const list = document.querySelector('.jdgm-rev-widg__reviews');
      if (!list) return;
      processReviews(list);
      if (!listObserver) {
        listObserver = new MutationObserver(function () { processReviews(list); });
        listObserver.observe(list, { childList: true, subtree: true });
      }
    }

    tick();
    new MutationObserver(tick).observe(document.body, { childList: true, subtree: true });
    window.addEventListener('load', tick);
    /* Filet de sécurité : Judge.me charge ses avis en AJAX, potentiellement lentement
       selon la connexion — on revérifie à intervalles réguliers jusqu'à 20 secondes,
       plutôt que de dépendre uniquement des observateurs. */
    [300, 800, 1500, 3000, 5000, 8000, 12000, 20000].forEach(function (delay) {
      setTimeout(tick, delay);
    });
  }

  /* =====================================================================
     CARROUSEL UGC (section avis) — barre de défilement custom mobile.
     Sur mobile la grille passe en flex à défilement horizontal ; on reflète
     la position de scroll dans une petite barre sous les cartes.
     ===================================================================== */
  function initUgcCarousels() {
    document.querySelectorAll('.sz-ugc-scrollbar').forEach(function (bar) {
      const thumb = bar.querySelector('.sz-ugc-scrollbar__thumb');
      const wrap = bar.closest('.sz-wrap') || bar.parentElement;
      const grid = wrap ? wrap.querySelector('.sz-ugc-grid') : null;
      if (!thumb || !grid) return;

      function update() {
        const scrollable = grid.scrollWidth - grid.clientWidth;
        if (scrollable <= 2) { bar.style.display = 'none'; return; }
        bar.style.display = '';
        const ratio = grid.clientWidth / grid.scrollWidth;
        const widthPct = Math.max(ratio * 100, 12);
        thumb.style.width = widthPct + '%';
        const progress = grid.scrollLeft / scrollable;
        thumb.style.left = (progress * (100 - widthPct)) + '%';
      }

      grid.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update);
      window.addEventListener('load', update);
      update();
    });
  }

  /* =====================================================================
     URGENCE — chiffre aléatoire (entre min et max) régénéré à chaque
     chargement de page, injecté dans .sz-urgency-n.
     ===================================================================== */
  function initUrgency() {
    document.querySelectorAll('.sz-urgency').forEach(function (el) {
      var min = parseInt(el.getAttribute('data-min'), 10);
      var max = parseInt(el.getAttribute('data-max'), 10);
      if (isNaN(min)) min = 4;
      if (isNaN(max)) max = 29;
      if (max < min) { var t = min; min = max; max = t; }
      var n = Math.floor(Math.random() * (max - min + 1)) + min;
      var out = el.querySelector('.sz-urgency-n');
      if (out) out.textContent = n;
    });
  }

  function init() {
    const product = getProductData();
    initGallery(product);
    initBundleStacks(product);
    initMobileBar(product);
    initAddons();
    initBuyActions();
    initUgcCarousels();
    initUrgency();
    initJudgemeReviews();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
